<div *ngIf="messengerService.isLoading$ | async" class="chat-message-list-loader">
  <mat-spinner strokeWidth="2" diameter="30" color="accent"></mat-spinner>
</div>
<ng-scrollbar #perfectScrollbar class="chat-message-list-container" [ngClass]="{ 'my-chat': isMyChat, 'attachment': isAttachment }">
  <div class="chat-message-list-group" *ngFor="let chatMessageGroup of chatMessageList | chatMessageListGroup; trackBy: trackByGroup">
    <ng-container>
      <div class="chat-message-list-group-date"><span> {{ chatMessageGroup.day | historyDayOfWeek }} </span></div>
      <lin-chat-message
        *ngFor="let chatMessage of chatMessageGroup.chatMessageList; trackBy: trackBy"
        [chatMessage]="chatMessage"
        [isMyMessage]="chatMessage?.user?.id === currentUser.id"
        [isGroupChat]="isGroupChat"
        [isMyChat]="isMyChat"
      >
      </lin-chat-message>
    </ng-container>
  </div>
</ng-scrollbar>
